import { render, staticRenderFns } from "./AddressesOverview.vue?vue&type=template&id=130fe0d6&scoped=true"
import script from "./AddressesOverview.vue?vue&type=script&lang=ts"
export * from "./AddressesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130fe0d6",
  null
  
)

export default component.exports